(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teamstatistics/assets/javascripts/views/statteampowerboxplay.js') >= 0) return;  svs.modules.push('/components/statistics/teamstatistics/assets/javascripts/views/statteampowerboxplay.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatTeamPowerBoxPlay = Backbone.View.extend({
    tagName: 'div',
    classId: 'StatTeamPowerBoxPlay',
    viewId: 'statistik',
    initialize: function(options) {
      this.modelReference = options.modelReference;
      this.options = options.options;

      this.powerPlayChart = new svs.sport.circle_graph.views.CircleGraph({
        homeTeam: 0,
        awayTeam: 0,
        width: 400,
        height: 400,
        id: 'power-play-chart-id'
      });

      this.boxPlayChart = new svs.sport.circle_graph.views.CircleGraph({
        homeTeam: 0,
        awayTeam: 0,
        width: 400,
        height: 400,
        id: 'box-play-chart-id'
      });
    },
    update: function(model) {
      this.modelReference = model;
      this.render({});
    },
    resize: function() {
      if (Object.prototype.hasOwnProperty.call(this.options.params, 'parent')) {
        this.options.params.parent.trigger('resize');
      }
    },
    render: function() {
      if (!this.modelReference) return;

      $(this.el).html(
        svs.statistics.teamstatistics.templates.statteampowerboxplay(
          this.applyFilters()
        )
      );
      this.resize();
      this.updatePowerBoxPlay();
      return this;
    },
    applyFilters: function() {
      var specialTeams = this.modelReference.get('specialTeams');
      return {
        specialTeams: specialTeams
      };
    },
    updatePowerBoxPlay: function() {
      var specialTeams = this.modelReference.get('specialTeams');
      if (((specialTeams || {}).powerplay || {}).ratio) {
        this.powerPlayChart.update({
          homeTeam: specialTeams.powerplay.ratio,
          awayTeam: 0,
          graphType: 'power-play'
        });
      }
      if (((specialTeams || {}).penaltykill || {}).ratio) {
        this.boxPlayChart.update({
          homeTeam: specialTeams.penaltykill.ratio,
          awayTeam: 0,
          graphType: 'power-play'
        });
      }
    },
    onDestroy: function() {
      this.undelegateEvents();
      if (this.modelReference) {
        this.modelReference.off('change', this.render, this);
      }
      this.remove();
      Backbone.View.prototype.remove.call(this);
    }
  });
})(Backbone, _, svs);

 })(window);